interface SectionHeadingProps {
  tagline?: string;
  title: string;
  description?: string;
  centered?: boolean;
}

export function SectionHeading({ tagline, title, description, centered = true }: SectionHeadingProps) {
  return (
    <div className={`${centered ? 'text-center' : ''} max-w-2xl ${centered ? 'mx-auto' : ''}`}>
      {tagline && (
        <span className="text-xs tracking-widest uppercase text-primary-500 font-medium">
          {tagline}
        </span>
      )}
      <h2 className="mt-2 text-2xl md:text-3xl font-heading text-foreground-900 tracking-wide">
        {title}
      </h2>
      {description && (
        <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}